/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3 } from 'three';
import { BasePanNavigator } from './BasePanNavigator';
import { NavUtils } from './NavUtils';
const INTERNAL_PAN_FACTOR = 0.05;
/**
 * Navigator for x / y panning
 */
export class PanNavigator extends BasePanNavigator {
    constructor(cam, el, speed = 1) {
        super(cam, el, speed);
        this.updatePivot = true;
    }
    pan(event) {
        const { movementX, movementY } = event.detail;
        const speed = this.speed * INTERNAL_PAN_FACTOR;
        const tx = -movementX * speed;
        const ty = movementY * speed;
        const camera = this._cam;
        const oldPos = new Vector3();
        camera.getWorldPosition(oldPos);
        camera.translateX(tx);
        camera.translateY(ty);
        const pos = new Vector3();
        camera.getWorldPosition(pos);
        pos.sub(oldPos);
        if (this.updatePivot) {
            NavUtils.getPivot(camera).add(pos);
        }
    }
}
//# sourceMappingURL=PanNavigator.js.map